import { gsap } from "gsap";

const _immagineSpezzaTesto = (() => {
    const init = (): void => {
        const mmDesktopString = "(min-width: 992px)";
        const mmMobileString = "(max-width: 991px)";

        const mm = gsap.matchMedia();

        document.querySelectorAll(".immagine-spezza-testo.animated").forEach((el) => {
            el = el.children[0];
            const imgContainer = el.querySelector(".media-container") as HTMLElement | null;
            const innerImg = imgContainer?.querySelector("img") as HTMLImageElement | null;

            if (!imgContainer) return;

            mm.add(mmDesktopString, () => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: "top top",
                        end: "+=500",
                        scrub: true,
                        pin: el,
                    },
                });

                tl.from(imgContainer, {
                    clipPath: "inset(7rem 35%)",
                    ease: "power2.in",
                });

                if (innerImg) {
                    tl.from(
                        innerImg,
                        {
                            scale: 1.1,
                            ease: "none",
                        },
                        "<",
                    );
                }
            });

            mm.add(mmMobileString, () => {
                // const tl = gsap.timeline({
                //     scrollTrigger: {
                //         trigger: el,
                //         start: "center center",
                //         end: "+=60",
                //         scrub: true,
                //         pin: el,
                //     },
                // });
                // tl.from(imgContainer, {
                //     clipPath: "inset(5rem 10%)",
                //     ease: "power2.in",
                // });
                // if (innerImg) {
                //     tl.from(
                //         innerImg,
                //         {
                //             scale: 1.1,
                //             ease: "none",
                //         },
                //         "<",
                //     );
                // }
            });
        });
    };

    return {
        init: init,
    };
})();

export default _immagineSpezzaTesto;
